import { useTranslation } from "react-i18next";
import { useState } from "react";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import ModalStateDialogComponent from "@CubeComponents/html/modal/ModalWithState";
import { markReviewMapper } from "./ReviewsConstants";
import TextBoxComponent from "@CubeComponents/form/TextBoxComponent";
import css from "./Reviews.module.css";

function MarkReviewModal({
  userResponse,
  closeModal,
  finalizeUserResponse,
  requireMandatoryComment,
  isLoadingSkip,
  setIsLoadingSkip,
}) {
  const { t } = useTranslation();
  const [comment, setComment] = useState("");

  const commentChangeHandler = (e) => {
    setComment(e.value);
  };

  const confirmMarkReview = () => {
    if ((requireMandatoryComment && comment.trim()) || !requireMandatoryComment) {
      if (typeof setIsLoadingSkip === "function") {
        setIsLoadingSkip(true);
      }
      finalizeUserResponse(userResponse, comment);
    }
  };

  const header = () => <p>{markReviewMapper[userResponse].heading}</p>;

  const content = () => (
    <div className={css.markReviewContent}>
      <p className={css.smallContent}>{markReviewMapper[userResponse].content}</p>
      <div>
        {requireMandatoryComment ? (
          <p className={css.commentHeading}>Comments*</p>
        ) : (
          <p className={css.commentHeading}>{t("Comments")}</p>
        )}
        <TextBoxComponent placeholder={t("Enter comments")} value={comment} onChange={commentChangeHandler} />
      </div>
    </div>
  );

  const footer = () => {
    const confirmDisabled = requireMandatoryComment && !comment.trim();

    return (
      <div className="flex gap-4">
        <ButtonComponent
          buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
          onClick={confirmMarkReview}
          disabled={confirmDisabled}
          loading={isLoadingSkip}
        >
          Confirm
        </ButtonComponent>
        <ButtonComponent buttonType={BUTTON_TYPES.BORDER_BUTTON} onClick={closeModal}>
          {t("Cancel")}
        </ButtonComponent>
      </div>
    );
  };
  return (
    <ModalStateDialogComponent
      isVisible
      zIndex={30000}
      headerTitle={header()}
      onCancel={closeModal}
      modelContent={content()}
      footerContent={footer()}
    />
  );
}

export default MarkReviewModal;
